import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

const IndexPage = ({ data }) => (
  <div className="front-page-content">
    <div className="front-page-content-box">
      <Link to="Indikator">
        <div className="no-img-div">
          <Img sizes={data.indexImage.sizes} />
        </div>
        <div style={{ fontSize: 20 }}>Vereinbarkeit Familie und Beruf</div>
        <div>Zu den Karten</div>
      </Link>
    </div>

    <div className="front-page-content-box">
      <p>
        Ein ausreichendes, bedarfsgerechtes und flexibles Angebot an
        Kinderbetreuungseinrichtungen ist wesentliche Voraussetzung für die
        Vereinbarkeit von Familie und Beruf. Die Erwerbschancen von Eltern
        hängen besonders von den zur Verfügung stehenden Betreuungsangeboten ab.
      </p>
      <p>
        Wo im Burgenland werden Kinder ganztägig betreut? Welche Gemeinde bietet
        Kinderbe­treuung, die die Anforderungen an die Vereinbarkeit von Beruf
        und Familie erfüllen?
      </p>
      <p>
        Der <Link to="Indikator">Kinderbetreuungsatlas</Link> Burgenland greift
        dieses Thema auf und bietet einen umfas­senden Überblick über die
        Situation im Be­reich der elementaren Bildungs- und
        Be­treuungseinrichtungen für Kinder im Alter von 0-10 Jahren in den
        burgenländischen Ge­meinden.
      </p>
      <p>
        Weiters steht mit dem <Link to="Planungstool">Planungstool</Link> ein
        Instrument für Gemeinden zur Verfügung, das einen Blick auf die
        zukünftig notwendigen lokalen Kinderbetreuungsangebote ermöglicht
      </p>
    </div>
  </div>
)

export default IndexPage

export const pageQuery = graphql`
  query IndexImageQuery {
    indexImage: imageSharp(
      id: { regex: "/Fotolia_112282099_Subscription.jpg/" }
    ) {
      sizes(maxWidth: 1240) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js